import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { pure } from '@dbk/ui-react-utils';
import get from 'lodash/get';

import { SEPARATOR_STROKE } from '../../../../../../src/constants';
import { shouldTruncate } from '../../../../../../src/utils/truncate-text';

import { HorizontalDashes } from '../../../../../../src/components/common/dashes'
import KeyValueListRow from './key-value-list-row';
import styles, { defaultColumnWidths } from './key-value-list-view.styles';

function KeyValueListView(props) {

  let {
    detailsGroups,
    row,
    renderFirstSeparator,
    renderLastSeparator,
    widths,
    defaultCurrency,
    screen,
    assetClass,
    subAssetdetailsGroups,
    assetCategory,
    assetGroupId,
    assetShortDesc,
    messages
  } = props;

 

  function hasShortDescription(group) {
    return !group.some(({ key, type }) =>
      type === 'description' && !shouldTruncate(get(row, key)));
  }

  // if(subAssetdetailsGroups == undefined) {
  //   detailsGroups = [];
  // }

  if (subAssetdetailsGroups != undefined) {
      if(assetShortDesc != null) {
        detailsGroups = subAssetdetailsGroups[assetCategory][assetShortDesc+'Groups'].detailsGroups;
    }
  }

  return (
    <View testID="details">
      { detailsGroups && detailsGroups
        .filter(hasShortDescription)
        .map((group, index) => (

                
          <View testID="details-group" key={index}>
            { 
              group.map(({ isTablet, isPhone }, j) => {
                const dashRow = (
                  (assetShortDesc=="cash" && index==0) ? <View key={j}></View>
                    :
                <View key={j}>
                  <HorizontalDashes stroke={SEPARATOR_STROKE} />
                </View>
              );
            
              
              if (screen.isSmall && isPhone) {
                if (j === 0 && (index !== 0)) {
                  return dashRow;
                }
              }
              if (!screen.isSmall && isTablet) {
                if (j === 0 && (index !== 0)) {
                  return dashRow;
                }
              }
            } ) }
            { group.map(({ label, key, type, minimumFractionDigits, maximumFractionDigits, isTablet, isPhone }, i) => {
              const detailRow = (
                <KeyValueListRow
                  label={messages[label]}
                  value={get(row, key)}
                  unit={get(row, `${key}Unit`) || defaultCurrency}
                  posCurr={row.positionCurrency}
                  type={type}
                  key={label || i}
                  widths={widths}
                  isPhone={isPhone}
                  isTablet={isTablet}
                  minimumFractionDigits={minimumFractionDigits}
                  maximumFractionDigits={maximumFractionDigits}
                />
              );
              if (screen.isSmall && isPhone) {
                return detailRow;
              }
              if (!screen.isSmall && isTablet) {
                return detailRow;
              }
            } ) }
          </View>
      ) ) }
      { renderLastSeparator &&
        <View>
          <HorizontalDashes stroke={SEPARATOR_STROKE} />
        </View>
      }
    </View>
  );
}

KeyValueListView.propTypes = {
  detailsGroups: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    key: PropTypes.string,
    type: PropTypes.string,
  }))),
  row: PropTypes.object,
  renderFirstSeparator: PropTypes.bool,
  renderLastSeparator: PropTypes.bool,
  widths: PropTypes.arrayOf(PropTypes.number),
  defaultCurrency: PropTypes.string,
  screen: PropTypes.shape({
    isSmall: PropTypes.bool,
  }),
};

KeyValueListView.defaultProps = {
  renderFirstSeparator: true,
  renderLastSeparator: true,
  widths: [0.6, 0.4],
  screen: {
    isSmall: false,
  },
};

export default pure(KeyValueListView);
